import { Observable } from 'rxjs';
import { StateObservable, ofType } from 'redux-observable';
import { mergeMap, withLatestFrom } from 'rxjs/operators';
import * as stripeConnect from '@webapp/sdk/stripe-connect';
import { Action } from 'redux';
import {
  CreateTransfer,
  CreateTransferError,
  CreateTransferSuccess,
} from '../action-creators';
import { CREATE_TRANSFER } from '../actions';
import AppState from '../../state';

export const createTransferEpic = (
  action$: Observable<Action>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Action, CreateTransfer>(CREATE_TRANSFER),
    withLatestFrom(state$),
    mergeMap(async ([action, state]) => {
      try {
        const id = `${state.user.profile?.id?.split('-')[0]}#${Date.now()}`;

        await stripeConnect.createTransfer({
          id,
          amount: action.amount.toObject(),
        });

        return new CreateTransferSuccess();
      } catch (err) {
        return new CreateTransferError((err as Error).message);
      }
    })
  );
